/* OSDTG collection filters: client-side, Custom Ink-style (chip bar + sidebar + active chips). */
(function () {
  var FAMILIES = [
    ['black', 'Black', '#111111'], ['white', 'White', '#ffffff'], ['grey', 'Grey', '#9b9b9b'],
    ['blue', 'Blue', '#1f4fbf'], ['teal', 'Teal', '#16857e'], ['green', 'Green', '#2e8b3d'],
    ['yellow', 'Yellow', '#f2d33c'], ['orange', 'Orange', '#ef7a1a'], ['red', 'Red', '#cc2020'],
    ['pink', 'Pink', '#f19cbd'], ['purple', 'Purple', '#7a3fa6'], ['brown', 'Brown & Tan', '#8b5a2b']
  ];
  var SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', 'XXL', '3XL', '4XL', '5XL', '6XL', 'YXS', 'YS', 'YM', 'YL', 'YXL', 'OSFA'];
  var PRICES = [
    ['0-1000', 'Under $10', 0, 1000], ['1000-1500', '$10 – $15', 1000, 1500],
    ['1500-2500', '$15 – $25', 1500, 2500], ['2500-up', '$25 & up', 2500, 1e12]
  ];
  var FITS = { oversized: 'Oversized & boxy', classic: 'Classic', womens: "Women's", youth: 'Youth' };
  var MATERIALS = { cotton: '100% cotton', blend: 'Blends', 'garment-dyed': 'Garment-dyed', performance: 'Performance' };
  var GROUPS = ['colors', 'vendor', 'sizes', 'price', 'fit', 'material'];

  function init(root) {
    var grid = root.querySelector('[data-cf-grid]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-cf-item]'));
    var state = { instock: false, sort: 'featured' };
    GROUPS.forEach(function (g) { state[g] = []; });

    function list(el, key) {
      var v = el.getAttribute('data-' + key) || '';
      return v ? v.split('|') : [];
    }
    function priceKey(el) {
      var p = parseInt(el.getAttribute('data-price'), 10) || 0;
      for (var i = 0; i < PRICES.length; i++) if (p >= PRICES[i][2] && p < PRICES[i][3]) return PRICES[i][0];
      return '';
    }
    function valuesOf(el, g) {
      if (g === 'colors' || g === 'sizes') return list(el, g);
      if (g === 'price') return [priceKey(el)];
      if (g === 'vendor') return [el.getAttribute('data-vendor')];
      return [el.getAttribute('data-' + g)];
    }
    function matches(el, skip) {
      if (state.instock && el.getAttribute('data-available') !== '1') return false;
      for (var i = 0; i < GROUPS.length; i++) {
        var g = GROUPS[i];
        if (g === skip || !state[g].length) continue;
        var vals = valuesOf(el, g);
        if (!state[g].some(function (s) { return vals.indexOf(s) !== -1; })) return false;
      }
      return true;
    }

    // ---- Build options (with counts) from the products on the page. ----
    var labels = {};
    function optionSet(g) {
      var seen = {};
      items.forEach(function (el) { valuesOf(el, g).forEach(function (v) { if (v) seen[v] = true; }); });
      var keys = Object.keys(seen);
      if (g === 'colors') return FAMILIES.filter(function (f) { return seen[f[0]]; }).map(function (f) { labels[f[0]] = f[1]; return f[0]; });
      if (g === 'price') return PRICES.filter(function (p) { return seen[p[0]]; }).map(function (p) { labels[p[0]] = p[1]; return p[0]; });
      if (g === 'fit') return Object.keys(FITS).filter(function (k) { return seen[k]; }).map(function (k) { labels[k] = FITS[k]; return k; });
      if (g === 'material') return Object.keys(MATERIALS).filter(function (k) { return seen[k]; }).map(function (k) { labels[k] = MATERIALS[k]; return k; });
      if (g === 'sizes') {
        return keys.sort(function (a, b) {
          var ia = SIZE_ORDER.indexOf(a), ib = SIZE_ORDER.indexOf(b);
          return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib) || a.localeCompare(b);
        });
      }
      return keys.sort(function (a, b) { return a.localeCompare(b); });
    }

    var familyHex = {};
    FAMILIES.forEach(function (f) { familyHex[f[0]] = f[2]; });

    GROUPS.forEach(function (g) {
      var box = root.querySelector('[data-cf-options="' + g + '"]');
      if (!box) return;
      var opts = optionSet(g);
      var group = box.closest('[data-cf-group]');
      if (opts.length < 2 && !(g === 'colors' && opts.length)) { group.hidden = true; return; }
      opts.forEach(function (v, i) {
        var label = labels[v] || v;
        var id = 'cf-' + g + '-' + i;
        var html;
        if (g === 'colors') {
          html = '<label class="osdtg-cf__sw" title="' + label + '"><input type="checkbox" data-cf-input="' + g + '" value="' + v + '" id="' + id + '">' +
            '<span class="osdtg-cf__sw-dot' + (v === 'white' ? ' is-light' : '') + '" style="background:' + familyHex[v] + '"></span>' +
            '<span class="visually-hidden">' + label + '</span></label>';
        } else if (g === 'sizes') {
          html = '<label class="osdtg-cf__pill"><input type="checkbox" data-cf-input="' + g + '" value="' + v + '"><span>' + v + '</span></label>';
        } else {
          html = '<label class="osdtg-cf__check' + (i >= 8 ? ' is-extra' : '') + '"><input type="checkbox" data-cf-input="' + g + '" value="' + v + '"><span class="osdtg-cf__box" aria-hidden="true"></span><span>' + label +
            '</span><span class="osdtg-cf__n" data-cf-n="' + g + '|' + v + '"></span></label>';
        }
        box.insertAdjacentHTML('beforeend', html);
      });
      if (g !== 'colors' && g !== 'sizes' && opts.length > 8) {
        var more = document.createElement('button');
        more.type = 'button';
        more.className = 'osdtg-cf__more';
        more.textContent = 'Show more';
        more.addEventListener('click', function () {
          var open = box.classList.toggle('show-all');
          more.textContent = open ? 'Show less' : 'Show more';
        });
        box.appendChild(more);
      }
    });

    // ---- Chip bar dropdowns mirror the sidebar groups. ----
    var chips = root.querySelector('[data-cf-chips]');
    root.querySelectorAll('[data-cf-group]').forEach(function (group) {
      if (group.hidden) return;
      var g = group.getAttribute('data-cf-group');
      var wrap = document.createElement('div');
      wrap.className = 'osdtg-cf__dd';
      wrap.innerHTML = '<button type="button" class="osdtg-cf__chip" aria-expanded="false">' + group.getAttribute('data-cf-label') +
        '<span class="osdtg-cf__chip-n" data-cf-chip-n="' + g + '"></span><svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true"><path d="M2 3.5l3 3 3-3" fill="none" stroke="currentColor" stroke-width="1.6"/></svg></button>' +
        '<div class="osdtg-cf__dd-panel" hidden></div>';
      var panel = wrap.querySelector('.osdtg-cf__dd-panel');
      var src = group.querySelector('[data-cf-options]');
      panel.innerHTML = src.innerHTML.replace(/ id="cf-[^"]+"/g, '');
      panel.className += ' ' + src.className;
      var btn = wrap.querySelector('button');
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = panel.hidden;
        root.querySelectorAll('.osdtg-cf__dd-panel').forEach(function (p) { p.hidden = true; p.previousElementSibling.setAttribute('aria-expanded', 'false'); });
        panel.hidden = !open;
        btn.setAttribute('aria-expanded', String(open));
      });
      panel.addEventListener('click', function (e) { e.stopPropagation(); });
      chips.appendChild(wrap);
    });
    document.addEventListener('click', function () {
      root.querySelectorAll('.osdtg-cf__dd-panel').forEach(function (p) { p.hidden = true; p.previousElementSibling.setAttribute('aria-expanded', 'false'); });
    });

    // ---- State <-> inputs <-> URL ----
    function readUrl() {
      var q = new URLSearchParams(location.search);
      GROUPS.forEach(function (g) { var v = q.get('f.' + g); state[g] = v ? v.split(',') : []; });
      state.instock = q.get('f.instock') === '1';
      state.sort = q.get('f.sort') || 'featured';
    }
    function writeUrl() {
      var q = new URLSearchParams(location.search);
      GROUPS.forEach(function (g) { state[g].length ? q.set('f.' + g, state[g].join(',')) : q.delete('f.' + g); });
      state.instock ? q.set('f.instock', '1') : q.delete('f.instock');
      state.sort !== 'featured' ? q.set('f.sort', state.sort) : q.delete('f.sort');
      var s = q.toString();
      history.replaceState(null, '', location.pathname + (s ? '?' + s : '') + location.hash);
    }
    function syncInputs() {
      root.querySelectorAll('[data-cf-input]').forEach(function (inp) {
        inp.checked = state[inp.getAttribute('data-cf-input')].indexOf(inp.value) !== -1;
      });
      root.querySelector('[data-cf-instock]').checked = state.instock;
      root.querySelector('[data-cf-sort]').value = state.sort;
    }

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-cf-input]')) {
        var g = t.getAttribute('data-cf-input');
        var idx = state[g].indexOf(t.value);
        if (t.checked && idx === -1) state[g].push(t.value);
        if (!t.checked && idx !== -1) state[g].splice(idx, 1);
      } else if (t.matches('[data-cf-instock]')) {
        state.instock = t.checked;
      } else if (t.matches('[data-cf-sort]')) {
        state.sort = t.value;
      } else return;
      update();
    });

    function clearAll() {
      GROUPS.forEach(function (g) { state[g] = []; });
      state.instock = false;
      update();
    }
    root.querySelectorAll('[data-cf-clear]').forEach(function (b) { b.addEventListener('click', clearAll); });

    // ---- Render ----
    var countEl = root.querySelector('[data-cf-count]');
    var activeEl = root.querySelector('[data-cf-active]');
    var emptyEl = root.querySelector('[data-cf-empty]');

    function update() {
      syncInputs();
      var shown = 0;
      items.forEach(function (el) {
        var ok = matches(el);
        el.hidden = !ok;
        if (ok) shown++;
      });
      countEl.textContent = shown + (shown === 1 ? ' style' : ' styles');
      var top = root.querySelector('[data-cf-count-top]');
      if (top) top.textContent = shown + ' of ' + items.length + ' styles';
      emptyEl.hidden = shown !== 0;

      // Counts: how many would show if this option were added (other groups applied).
      root.querySelectorAll('[data-cf-n]').forEach(function (n) {
        var parts = n.getAttribute('data-cf-n').split('|');
        var g = parts[0], v = parts.slice(1).join('|');
        var c = 0;
        items.forEach(function (el) { if (matches(el, g) && valuesOf(el, g).indexOf(v) !== -1) c++; });
        n.textContent = '(' + c + ')';
        n.closest('label').classList.toggle('is-zero', c === 0);
      });
      GROUPS.forEach(function (g) {
        var n = root.querySelector('[data-cf-chip-n="' + g + '"]');
        if (n) n.textContent = state[g].length ? ' · ' + state[g].length : '';
        if (n) n.closest('button').classList.toggle('is-active', state[g].length > 0);
      });

      // Active chips
      var html = '';
      GROUPS.forEach(function (g) {
        state[g].forEach(function (v) {
          html += '<button type="button" class="osdtg-cf__tag" data-cf-remove="' + g + '|' + v + '">' + (labels[v] || v) + ' <span aria-hidden="true">×</span><span class="visually-hidden">Remove filter</span></button>';
        });
      });
      if (state.instock) html += '<button type="button" class="osdtg-cf__tag" data-cf-remove="instock|1">In stock <span aria-hidden="true">×</span></button>';
      if (html) html += '<button type="button" class="osdtg-cf__clear-link" data-cf-clear-inline>Clear all</button>';
      activeEl.innerHTML = html;

      // Sort
      var sorted = items.slice().sort(function (a, b) {
        if (state.sort === 'price-asc') return a.getAttribute('data-price') - b.getAttribute('data-price');
        if (state.sort === 'price-desc') return b.getAttribute('data-price') - a.getAttribute('data-price');
        if (state.sort === 'newest') return b.getAttribute('data-created') - a.getAttribute('data-created');
        if (state.sort === 'title') return a.getAttribute('data-title').localeCompare(b.getAttribute('data-title'));
        return a.getAttribute('data-index') - b.getAttribute('data-index');
      });
      sorted.forEach(function (el) { grid.appendChild(el); });
      writeUrl();
    }

    activeEl.addEventListener('click', function (e) {
      var t = e.target.closest('button');
      if (!t) return;
      if (t.hasAttribute('data-cf-clear-inline')) return clearAll();
      var parts = t.getAttribute('data-cf-remove').split('|');
      if (parts[0] === 'instock') state.instock = false;
      else state[parts[0]] = state[parts[0]].filter(function (v) { return v !== parts.slice(1).join('|'); });
      update();
    });

    // ---- Mobile drawer ----
    var side = root.querySelector('[data-cf-side]');
    var scrim = root.querySelector('[data-cf-scrim]');
    function drawer(open) {
      side.classList.toggle('is-open', open);
      scrim.hidden = !open;
      document.documentElement.classList.toggle('osdtg-cf-lock', open);
    }
    root.querySelectorAll('[data-cf-open-drawer]').forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); drawer(true); }); });
    root.querySelectorAll('[data-cf-close-drawer]').forEach(function (b) { b.addEventListener('click', function () { drawer(false); }); });
    scrim.addEventListener('click', function () { drawer(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') drawer(false); });

    readUrl();
    update();
  }

  function boot() { document.querySelectorAll('[data-osdtg-cf]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
